
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rank/fans-count",
      function () {
        return require("private-next-pages/rank/fans-count.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rank/fans-count"])
      });
    }
  